import { render, staticRenderFns } from "./messageGroupLog.vue?vue&type=template&id=7d0bd286"
import script from "./messageGroupLog.vue?vue&type=script&lang=js"
export * from "./messageGroupLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports